import { ChangeDetectionStrategy, Component, inject, input, output } from '@angular/core';
import { RouterLink } from '@angular/router';

import { TranslateModule } from '@ngx-translate/core';
import { APP_VERSION } from '@imagise/shared';

const SUPPORTED_FORMATS = [
  'APNG',
  'DICOM',
  'ICO',
  'TIF',
  'BMP',
  'DJVU',
  'JPEG',
  'TIFF',
  'DCM',
  'DNG',
  'JPEG2000',
  'PNG',
  'WEBP',
  'DIB',
  'GIF',
  'JPG',
  'TGA',
  'SVG',
  'EPS',
  'CAD',
  'AVIF',
  'EMF',
  'WMF',
].sort();

@Component({
  selector: 'lib-footer',
  imports: [TranslateModule, RouterLink],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FooterComponent {
  readonly showAnalyticsSettings = input(false);
  readonly openAnalyticsSettings = output<void>();

  protected readonly currentYear = new Date().getFullYear();
  protected readonly appVersion = inject(APP_VERSION, { optional: true }) ?? '1.0.0';
  protected readonly formats = SUPPORTED_FORMATS;
}
